import { inject, Injectable } from '@angular/core';
import { GuidelineService } from 'shared/domain';

import { Reference } from '@treetop/shared/model';

export type GuidelineReferenceWithNumber = Reference & {
  referenceNumber: number;
};

@Injectable()
export class ReferenceNumberingService {
  private guidelineService = inject(GuidelineService);

  public orderedReferences = this.guidelineService.orderedReferences;
}
